<template>
  <div class="item-list">
    <p class="p1"><span class="span1">{{item.comName}}</span><span>审核未通过</span></p>
    <p>统一征信代码: <span>{{item.uscc}}</span></p>
    <p>注册时间: <span>{{conversionTime(item.createTime)}}</span></p>
    <p>环保负责人姓名: <span>{{item.managerName}}</span></p>
    <p>环保负责人电话: <span>{{item.managerPhone}}</span></p>
    <div class="btns">
      <van-button type="default" size="small" @click="seeClick()">查看</van-button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminShjj',
  props: [
    'item'
  ],
  watch: {
    item(newval, oldval) {
      // console.log(newval)
    }
  },
  data () {
    return {
      modifyId: '',
      detailsId: ''
    }
  },
  created() {
    this.modifyId = this.item.id
  },
  methods: {
    seeClick(item) { // 查看资料
      this.$router.push({path: 'Basic', query: {admin: true, detailsId: this.modifyId}})
    }
  }
}

</script>
<style lang="scss" scoped>
.item-list {
  margin: 7px 0;
  padding: 10px;
  border-radius: 3px;
  background-color: #fff;
  .p1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 7px;
    .span1 {
      color: #333;
      font-weight: 600;
      font-size: 18px;
    }
  }
  p {
    margin-bottom: 3px;
    color: #999;
    font-size: 16px;
    span {
      color: #333;
    }
  }
  .btns {
    display: flex;
    justify-content: flex-end;
  }
}
::v-deep .van-button--small {
  margin-right: 5px;
}
</style>
